import { Eye, InfoCircle } from "iconoir-react";
import { FormEvent } from "react";
import { FormProvider, UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import {
  ControlledInput,
  ControlledTextArea,
  PageHeader,
} from "shared/components";
import { Flex } from "styled-system/jsx";

type WidgetDetailsViewProps = {
  form: UseFormReturn<{
    name: string;
    description?: string;
  }>;
  formId: string;
  onSubmit: (e?: FormEvent) => Promise<void>;
  onOpenPreviewModal: () => void;
};

export const WidgetDetailsView = ({
  form,
  formId,
  onSubmit,
  onOpenPreviewModal,
}: WidgetDetailsViewProps) => {
  const { t } = useTranslation();

  return (
    <Flex flexDir={"column"} gap={"400"}>
      <PageHeader
        title={`${t("widgets:PAGE.WIDGET")} ${t("widgets:DETAILS.TABS.DETAILS")}`}
        Icon={InfoCircle}
        ctaButtonCopy={t("widgets:DETAILS.PAGE_ACTIONS.PREVIEW_WIDGET")}
        ctaButtonProps={{ Icon: Eye, onClick: onOpenPreviewModal }}
      />
      <FormProvider {...form}>
        <form id={formId} onSubmit={onSubmit}>
          <Flex
            flexDir="column"
            justifyContent="flex-start"
            alignItems="flex-start"
            gap="150"
          >
            <ControlledInput
              flex="1"
              inputMode="text"
              name="name"
              label={t("widgets:DETAILS.FORM.LABELS.NAME")}
            />
            <ControlledTextArea
              flex="1"
              inputMode="text"
              name="description"
              label={t("widgets:DETAILS.FORM.LABELS.DESCRIPTION")}
            />
          </Flex>
        </form>
      </FormProvider>
    </Flex>
  );
};
